import { Box, Button, HStack, Image } from "components/ui";
import { H4, Typography } from "components/ui/Typography";
import React from "react";

const TrainingItem = () => {
	return (
		<Box flexDirection="row" gap={24} paddingHorizontal={20} paddingVertical={24}>
			<Box>
				<Box flex={1} maxHeight={120} maxWidth={140} aspectRatio={35 / 26} borderRadius={20}>
					<Image
						bg="$basicwhite"
						sx={{
							width: "100%",
							height: "100%",
							minWidth: 120,
						}}
						resizeMode="contain"
						borderRadius={20}
						// @ts-ignore
						// source={process.env.EXPO_PUBLIC_ABCO_API_CDNURL + itemInfo.imageUrl + "?width=200&quality=75&format=webp"}
						source=""
						alt=""
					/>
				</Box>
			</Box>
			<Box flex={1}>
				<H4 sx={{ fontFamily: "Roboto_700Bold" }}>Workplace Health and Safety in Commercial Cleaning</H4>
				<Typography.ParagraphSmall sx={{ display: "flex", flex: 1 }}>Placeholder information about location of the training course or how to access it .</Typography.ParagraphSmall>
				<Typography.ParagraphSmall>Item price: $125.00</Typography.ParagraphSmall>
			</Box>
			<Box maxWidth={232}>
				<Button gap={8} padding={12} bg="$secondary" borderRadius={16} onPress={() => {}}>
					<Typography weight="bold">Learn More</Typography>
				</Button>
			</Box>
		</Box>
	);
};

export default TrainingItem;
